export type User = {
  id?: number;
  email: string;
  isEmailConfirmed?: boolean;
  lastName: string;
  firstName: string;
  kanaFirstName: string;
  kanaLastName: string;
  key?: number;
  upgradedServiceId?: number;
  serviceIds?: number[];
};

const defaultUser: User = {
  id: 0,
  email: '',
  isEmailConfirmed: false,
  firstName: '',
  lastName: '',
  kanaFirstName: '',
  kanaLastName: '',
};

export const userFactory = (userAttrs?: {
  [P in keyof User]?: User[P];
}): User => ({ ...defaultUser, ...userAttrs });
